var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hello screen-spacing" }, [
    _c(
      "div",
      {},
      [
        _c("div", { staticClass: "h1 display-inline" }, [_vm._v("Venue List")]),
        _c(
          "router-link",
          { staticClass: "btn mb-3", attrs: { to: "/Club-Details" } },
          [_c("i", { staticClass: "fa-solid fa-plus" })]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-4" },
      _vm._l(_vm.venueList, function (item, index) {
        return _c("div", { key: index, staticClass: "row card m-3" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title mt-1" }, [
              _vm._v(_vm._s(item.venue_name)),
            ]),
            _c("h6", { staticClass: "card-sub-title text-muted mt-1" }, [
              _vm._v(_vm._s(item.address)),
            ]),
            _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary mx-1",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.navigateToClubEdit(item, index)
                    },
                  },
                },
                [_vm._v("Edit")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary mx-1",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteClub(item)
                    },
                  },
                },
                [_vm._v("Delete")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary mx-1",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.navigateToClubStyle(item, index)
                    },
                  },
                },
                [_vm._v("Adjust Style")]
              ),
            ]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }